/* src/app/admin-dashboard/site-system/inventory/svinn/svinn.component.css */
.svinn-container {
  padding: 15px;
  max-width: 800px;
  margin: 0 auto;
}
.header-actions {
  margin-bottom: 20px;
  position: sticky;
  top: 0;
  z-index: 10;
  background: white;
  padding-top: 5px;
}
.search-bar {
  width: 100%;
}
.food-items-list {
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-bottom: 80px;
}
.food-item-card {
  transition: all 0.2s ease;
  border-left: 3px solid transparent;
  border-radius: 0 !important;
  margin: 0 !important;
  box-shadow: none !important;
  border-bottom: 1px solid #e5eaef;
}
.food-item-card.modified {
  background-color: #ecf2ff;
  border-left-color: #5d87ff;
}
.item-details {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 3px;
  padding: 4px 8px;
  min-height: 28px;
}
.item-name {
  flex: 1;
  font-weight: 500;
  font-size: 0.95rem;
  color: #2a3547;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.quantity-controls {
  display: flex;
  align-items: center;
  gap: 4px;
  background: #f2f6fa;
  padding: 2px 6px;
  border-radius: 4px;
}
.quantity-input {
  width: 35px;
  text-align: center;
  border: none;
  background: transparent;
  font-size: 1rem;
  font-weight: 600;
  color: #2a3547;
  height: 30px;
  -moz-appearance: textfield;
}
.quantity-input::-webkit-outer-spin-button,
.quantity-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.synced-icon {
  color: #13deb9;
}
.modified-icon {
  color: #5d87ff;
}
@media screen and (max-width: 768px) {
  .svinn-container {
    padding: 0;
  }
  .header-actions {
    margin-bottom: 15px;
    padding: 10px;
  }
  .quantity-controls button {
    width: 32px !important;
    height: 32px !important;
    padding: 0 !important;
  }
  .submit-button {
    background-color: #5d87ff !important;
  }
}
.food-item-card.modified {
  background-color: #f0f7ff;
  border-left-color: #2196f3;
}
.item-details {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}
.item-name {
  flex: 1;
  font-weight: 500;
  font-size: 1.1rem;
  color: #333;
}
.quantity-controls {
  display: flex;
  align-items: center;
  background: #f5f5f5;
  border-radius: 25px;
  padding: 2px 8px;
}
.quantity-input {
  width: 45px;
  text-align: center;
  border: none;
  background: transparent;
  font-size: 1.2rem;
  font-weight: 600;
  -moz-appearance: textfield;
}
.quantity-input::-webkit-outer-spin-button,
.quantity-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.status-indicator {
  width: 24px;
  display: flex;
  justify-content: center;
}
.synced-icon {
  color: #4caf50;
}
.modified-icon {
  color: #ff9800;
}
.form-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 15px;
  background: rgba(255, 255, 255, 0.9);
  -webkit-backdrop-filter: blur(5px);
  backdrop-filter: blur(5px);
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: center;
  z-index: 100;
}
.submit-button {
  width: 100%;
  max-width: 400px;
  height: 50px;
  font-size: 1.1rem;
  border-radius: 25px;
}
@media (max-width: 600px) {
  .item-name {
    font-size: 1rem;
  }
  .quantity-controls button {
    transform: scale(1.2);
  }
  .svinn-container {
    padding: 10px;
  }
}
::ng-deep .food-item-card .mat-mdc-card-content {
  padding: 0 !important;
}
::ng-deep .food-item-card .mat-mdc-card-content:first-child {
  padding-top: 0 !important;
}
/*# sourceMappingURL=svinn.component.css.map */
